// Page Routes

export const HOME_PAGE_ROUTE = "/dev.pms";
export const LOGIN_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/login`;
export const SIGNUP_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/signup`;
export const INVITATIONS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/invitations`;
export const INVITATIONS_ACCEPT_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/invitations/accept`;
export const LOGIN_COMPLETE_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/complete`;
export const RESET_PASSWORD_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/password`;
export const RESET_PASSWORD_LINK_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/reset-password`;
export const DASHBOARD_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard`;
export const USERS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/users`;
export const PROJECTS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/projects`;
export const ACTIVITIES_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/activities`;
export const ANALYTICS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/analytics`;
export const FILES_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/files`;
export const GIS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/gis`;
export const SETTINGS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/settings`;
export const PROFILE_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/settings/profile`;
export const FINANCIAL_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/financial`;
export const FINANCIAL_CONTRACTOR_COMPANIES_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/financial/contractors`;
export const FINANCIAL_PRICE_LIST_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/financial/price_lists`;
export const FINANCIAL_BOQ_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/financial/boq`;
export const FINANCIAL_BOQ_MAIN_ROUTE = `${HOME_PAGE_ROUTE}/dashboard/financial/boq/main`;

// New Design Routes
export const USER_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/users`;
export const PROJECT_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/project`;
export const PINNED_PROJECT_PAGE_ROUTE = `${PROJECT_PAGE_ROUTE}/pinned-project`;
export const FILES_FOLDER_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/files`;
export const NEW_DASHBOARD_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/dashboard`;
export const PROJECT_GROUP_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/project-group`;
export const SETTING_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/setting`;
export const FINANCE_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/finance`;
export const MY_TASKS_PAGE_ROUTE = `${HOME_PAGE_ROUTE}/v1/my-tasks`;

